import {
  useLiveAnnouncer,
  type UseLiveAnnouncer,
} from '@/shared/hooks/useLiveAnnouncer/useLiveAnnouncer';

export type UseMediaAnnouncer = UseLiveAnnouncer;

/** The `uiKit` sentence a media field owes when it refuses an edit. */
const READ_ONLY_REFUSAL_KEY = 'media.readOnlyRefused';

/**
 * What the media family says out loud.
 *
 * The family's own vocabulary over the shared `useLiveAnnouncer`: one sentence
 * for a refusal, wherever it comes from, so the picker and the library dialog
 * cannot word the same event two ways. Everything specific to one moment — an
 * upload's progress, the asset that was chosen, the one that turned out to be
 * missing — goes through `say`.
 *
 * A media control has more to announce than the other three families, because
 * most of what it does is invisible to a screen reader: an image appearing is
 * nothing at all unless somebody says so.
 */
export function useMediaAnnouncer(): UseMediaAnnouncer {
  return useLiveAnnouncer(READ_ONLY_REFUSAL_KEY);
}
